import React from 'react'
import Banner from './Banner'
import { FlexRow, Text, Icon } from 'elements'

export default function IntegrationHelpBanner({ onClose }) {
  return (
    <Banner onClose={onClose}>
      <FlexRow>
        <Icon name="info-circle" size="medium" mr="xlarge" />
        <Text color="inherit" fontWeight="bold">
          Your first report with this integration may take longer while we sync your information.
        </Text>
      </FlexRow>
    </Banner>
  )
}
